const electronUserAgent = RegExp(" electron/", "i");
export const IS_ELECTRON = electronUserAgent.test(navigator.userAgent);

const webApiUrl = `${window.location.protocol}//${window.location.host}`;

export const API_URL = IS_ELECTRON ? process.env.API_URL : webApiUrl;
